import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { IInspectionItem } from '../../models/response/InspectionResponse';
import { usePatchStartInspectionMutation } from '../../services/modules/inspection';
import { setCurrentCar } from '../../store/inspection';
import { Header } from '../../ui';

import { Content, TopTab, TopTabContainer } from './InspectionListElements';
import { TabHandler } from './TabHandler';

enum ETabs {
  ALL = 'all',
  INSPECTED = 'inspected',
  READY = 'ready',
  IN_PROGRESS = 'in_progress',
}

export const InspectionList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const tabList = [
    { slug: ETabs.ALL, title: t('inspection.all') },
    { slug: ETabs.READY, title: t('inspection.ready') },
    { slug: ETabs.IN_PROGRESS, title: t('inspection.in_progress') },
    { slug: ETabs.INSPECTED, title: t('inspection.inspected') },
  ];

  const [counts, setCounts] = useState<{ [name: string]: number }>({});
  const [tab, setTab] = useState<ETabs>(ETabs.IN_PROGRESS);
  const onChangeTopTab = (tab: ETabs) => {
    setTab(tab);
    window.scrollTo({
      top: 0,
    });
  };

  const [startInspection, { data, isSuccess }] = usePatchStartInspectionMutation();

  const onClickItem = (item: IInspectionItem) => {
    if (item.status === 1) {
      startInspection(item.slug);
    } else {
      navigate(`/${item.slug}`);
    }
    dispatch(setCurrentCar(item));
  };

  useEffect(() => {
    if (isSuccess && data) {
      navigate(`/${data.slug}`);
    }
  }, [isSuccess, data]);

  return (
    <>
      <Header title={t('inspection.inspection')}>
        <TopTabContainer>
          {tabList.map((t) => (
            <TopTab key={t.slug} isSelected={tab === t.slug} onClick={() => onChangeTopTab(t.slug)}>
              <label>{`${t.title} (${counts?.[t.slug] || '0'})`}</label>
            </TopTab>
          ))}
        </TopTabContainer>
      </Header>
      {tabList.map((t) => (
        <Content key={t.slug} isHidden={tab !== t.slug}>
          <TabHandler
            status={t.slug}
            onClickItem={onClickItem}
            setCount={(count) =>
              setCounts((state) => {
                return { ...state, [t.slug]: count };
              })
            }
          />
        </Content>
      ))}
    </>
  );
};
